var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "464px",
    height: "465px",
    viewBox: "0 0 464 465",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mantenimiento") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UIKIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mantenimiento"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.737571,308.94432 L297.475642,320.21015 L269.194041,348.483951 L370.879078,450.168987 C389.595647,468.885557 419.944732,468.885557 438.665202,450.168987 L444.313721,444.520469 L308.737571,308.94432 Z",
    id: "Path",
    fill: "#00A09A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.737571,308.94432 L444.313721,444.520469 L449.962239,438.87195 C468.678808,420.15148 468.678808,389.802396 449.962239,371.081926 L348.277202,269.396888 L320.003401,297.678491 L308.737571,308.94432 Z",
    id: "Path",
    fill: "#00C4B3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#7E8083",
    points: "14.9794968 15.1862448 3.71756758 26.4520747 31.9172513 88.6052835 69.2255595 92.0419865 178.837248 201.571755 190.103077 190.305925"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C2C2C2",
    points: "201.365007 179.043996 91.8352385 69.4323085 88.3985355 32.1239993 26.2453267 3.92041493 14.9794968 15.1862448 190.103077 190.305925"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C2C2C2",
    points: "269.197941 269.400789 280.459871 258.134959 320.003401 297.678491 308.741472 308.94432"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#7E8083",
    points: "257.932111 280.662718 269.197941 269.400789 308.741472 308.94432 297.475642 320.21015"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#78B9EB",
    points: "308.737571 308.940419 320.003401 297.674589 320.007302 297.678491 308.741472 308.94432"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#78B9EB",
    points: "297.471742 320.202348 308.737571 308.940419 308.741472 308.94432 297.479544 320.21015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.700678,74.6244198 L392.462817,134.784264 L341.653456,117.84651 L19.6527882,439.847178 L25.2857022,445.476192 C44.0295785,464.173257 74.3708609,464.173257 93.1147372,445.476192 L318.404028,220.1869 C358.556101,230.93781 401.356893,218.536816 429.540972,187.988784 C457.725051,157.440753 466.646434,113.781761 452.700678,74.6244198 Z",
    id: "Path",
    fill: "#C24308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.875546,6.79928748 C345.718204,-7.14646827 302.059212,1.77491459 271.511181,29.9589936 C240.963151,58.1430727 228.562156,100.943864 239.313065,141.095937 L14.023774,366.385229 C-4.67329143,385.129105 -4.67329143,415.470387 14.023774,434.214263 L19.6527882,439.804268 L229.646609,229.853357 L341.653456,117.84651 L324.715701,67.0371489 L384.875546,6.79928748 Z",
    id: "Path",
    fill: "#E9530D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.a94bdad1f7f33a55906e8d597ec5b54f.svg";
export { ForwardRef as ReactComponent };